import React from "react";

type FlagToggleCardProps = {
  label: string;
  value: boolean;
  onToggle: (next: boolean) => void;
};

export function FlagToggleCard({ label, value, onToggle }: FlagToggleCardProps): JSX.Element {
  return (
    <section className="tw-flex tw-items-center tw-gap-3 tw-rounded-2xl tw-border tw-border-slate-100 tw-bg-white tw-px-4 tw-py-3">
      <button
        type="button"
        onClick={() => onToggle(!value)}
        aria-pressed={value}
        className={`tw-relative tw-inline-flex tw-h-7 tw-w-14 tw-flex-shrink-0 tw-items-center tw-rounded-full tw-transition ${
          value ? "tw-bg-[#03234a]" : "tw-bg-slate-300"
        }`}
      >
        <span
          className={`tw-inline-block tw-h-6 tw-w-6 tw-transform tw-rounded-full tw-bg-white tw-shadow tw-transition ${
            value ? "tw-translate-x-7" : "tw-translate-x-1"
          }`}
        />
      </button>
      <p className="tw-text-[0.65rem] tw-font-semibold tw-uppercase tw-tracking-wide tw-text-slate-400" style={{ height:"20px", display:"flex", paddingTop:"10px"}}>
        {label}
      </p>
    </section>
  );
}
